import React, { useState } from 'react';
import { useCart } from '../CartContext';
import toast from 'react-hot-toast';
import './ProductDetailModal.css';

export default function ProductDetailModal({ product, onClose }) {
  const { dispatch, items } = useCart();
  const [qty, setQty] = useState(1);
  const [activeImg, setActiveImg] = useState(0);
  const [wishlisted, setWishlisted] = useState(() => {
    const w = JSON.parse(localStorage.getItem('freshmart_wishlist') || '[]');
    return w.includes(product.id);
  });

  const cartItem = items.find(i => i.id === product.id);

  // Extra images for the product (use the main + variations)
  const images = [
    product.image,
    `https://images.unsplash.com/photo-${1540420773420 + product.id}?w=600&q=80`,
    product.image?.replace('w=400', 'w=600') || product.image,
  ];

  const handleAddToCart = () => {
    for (let i = 0; i < qty; i++) {
      dispatch({ type: 'ADD_ITEM', item: product });
    }
    toast.success(`${product.name} ×${qty} added to cart! 🛒`);
    onClose();
  };

  const toggleWishlist = () => {
    const w = JSON.parse(localStorage.getItem('freshmart_wishlist') || '[]');
    const updated = wishlisted ? w.filter(id => id !== product.id) : [...w, product.id];
    localStorage.setItem('freshmart_wishlist', JSON.stringify(updated));
    setWishlisted(!wishlisted);
    toast(wishlisted ? 'Removed from wishlist' : '❤️ Added to wishlist!');
  };

  const stars = Array.from({ length: 5 }, (_, i) => i < Math.floor(product.rating) ? '★' : '☆');

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="product-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>

        <div className="modal-layout">
          {/* Left: Images */}
          <div className="modal-images">
            <div className="main-img-wrap">
              <img src={images[activeImg]} alt={product.name} onError={e => e.target.src = product.image} />
              {product.badge && <span className="modal-badge">{product.badge}</span>}
            </div>
            <div className="img-thumbs">
              {images.map((img, i) => (
                <button
                  key={i}
                  className={`img-thumb ${activeImg === i ? 'active' : ''}`}
                  onClick={() => setActiveImg(i)}
                >
                  <img src={img} alt="" onError={e => e.target.src = product.image} />
                </button>
              ))}
            </div>
          </div>

          {/* Right: Details */}
          <div className="modal-details">
            <div className="modal-category">{product.category}</div>
            <h2 className="modal-name">{product.name}</h2>

            <div className="modal-rating-row">
              <span className="modal-stars">{stars.join('')}</span>
              <span className="modal-rating-val">{product.rating}</span>
              <span className="modal-reviews">({product.reviews} reviews)</span>
            </div>

            <p className="modal-description">{product.description || 'Fresh, high-quality product sourced directly from local farms and delivered to your doorstep.'}</p>

            <div className="modal-price-row">
              <span className="modal-price">₹{product.price}</span>
              <span className="modal-unit">per {product.unit}</span>
              {product.stock < 20 && (
                <span className="modal-low-stock">⚠️ Only {product.stock} left!</span>
              )}
            </div>

            <div className="modal-tags">
              <span>🌿 Farm Fresh</span>
              <span>✅ Quality Checked</span>
              <span>🚀 30-min Delivery</span>
              {product.badge && <span>🏆 {product.badge}</span>}
            </div>

            <div className="modal-qty-row">
              <label>Quantity</label>
              <div className="modal-qty-ctrl">
                <button onClick={() => setQty(q => Math.max(1, q - 1))}>−</button>
                <span>{qty}</span>
                <button onClick={() => setQty(q => Math.min(product.stock, q + 1))}>+</button>
              </div>
              <span className="modal-total-price">= ₹{(product.price * qty).toLocaleString()}</span>
            </div>

            <div className="modal-actions">
              {cartItem ? (
                <div className="modal-in-cart">
                  <span>✅ Already in cart ({cartItem.qty} units)</span>
                  <button className="modal-add-more" onClick={handleAddToCart}>Add {qty} More</button>
                </div>
              ) : (
                <button className="modal-add-btn" onClick={handleAddToCart}>
                  🛒 Add to Cart · ₹{(product.price * qty).toLocaleString()}
                </button>
              )}
              <button
                className={`modal-wishlist-btn ${wishlisted ? 'wishlisted' : ''}`}
                onClick={toggleWishlist}
              >
                {wishlisted ? '❤️' : '🤍'} {wishlisted ? 'Wishlisted' : 'Wishlist'}
              </button>
            </div>

            <div className="modal-info-grid">
              <div className="modal-info-item">
                <span>📦</span><div><strong>Free Delivery</strong><p>on orders above ₹500</p></div>
              </div>
              <div className="modal-info-item">
                <span>🔄</span><div><strong>Easy Returns</strong><p>within 24 hours</p></div>
              </div>
              <div className="modal-info-item">
                <span>🌿</span><div><strong>Fresh Guarantee</strong><p>100% fresh or refund</p></div>
              </div>
              <div className="modal-info-item">
                <span>🔒</span><div><strong>Secure Payment</strong><p>UPI, Card, COD</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
